import styled from "@emotion/styled";

import DisplayType from "utils/displayType";
import FaqSection from "router/contact/components/FaqSection";
import React, { Suspense, useEffect, useState } from "react";
import { DropdownSelector } from "component/selector/DropdownSelector";
import { useLanguage } from "i18n/LanguageContext";
import Footer from "../../component/footer/Footer";
import Policy20220101 from "./policy_contents/Policy20220101";
import Policy20230601 from "./policy_contents/Policy20230601";

const Policy20230601En = React.lazy(
  () => import("./policy_contents/Policy20230601En")
);
const Policy20220101En = React.lazy(
  () => import("./policy_contents/Policy20220101En")
);

interface PrivatyPolicyVersion {
  title: string;
  policy: JSX.Element;
}

const PrivacyPolicy = () => {
  const mode = DisplayType();
  const { language, t } = useLanguage();
  const version: PrivatyPolicyVersion[] = [
    {
      title: "2023.06.01",
      policy:
        language === "en" ? (
          <Suspense fallback={<div />}>
            <Policy20230601En />
          </Suspense>
        ) : (
          <Policy20230601 />
        ),
    },
    {
      title: "2022.01.01",
      policy:
        language === "en" ? (
          <Suspense fallback={<div />}>
            <Policy20220101En />
          </Suspense>
        ) : (
          <Policy20220101 />
        ),
    },
  ];

  const [selectedVersionId, updateSelectedVersionId] = useState<number>(0);
  const [selectedVersion, updateSelectedVersion] =
    useState<PrivatyPolicyVersion>(version[0]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);
  return (
    <Container>
      <HeaderContainer
        className={`${mode === "Mobile" ? "font-sub-title2" : "font-title"}`}
      >
        <span style={{ color: "var(--black)" }}>{t("policy", "title")}</span>
        <div
          className={`center ${
            mode === "Mobile" ? "font-body4" : "font-body2"
          }`}
          style={{
            color: "var(--grey-40)",
            textAlign: "center",
            padding: mode === "Mobile" ? "0 20px" : "0",
          }}
        >
          {t("policy", "descCompany")}
          {mode === "Mobile" && <br />}
          {t("policy", "descDomain")}
          {mode === "Mobile" && <br />} {t("policy", "descLaw")} <br />
          {t("policy", "descPurpose")}
          {mode === "Mobile" && <br />} {t("policy", "descProcess")}
          <br /> {t("policy", "descConclusion")}
        </div>
      </HeaderContainer>
      <div
        className="limit__body"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 80,
          gap: 16,
        }}
      >
        <div className={`${mode === "Mobile" ? "font-body4" : "font-body2"}`}>
          {t("policy", "versionLabel")}
        </div>
        <DropdownSelector
          width={180}
          itemList={version.map((item, index) => ({
            id: index,
            text: item.title,
            data: item,
          }))}
          selectedId={selectedVersionId}
          onChangeItem={(item) => {
            if (item.data) {
              updateSelectedVersionId(item.id);
              updateSelectedVersion(item.data);
            }
          }}
        />
      </div>
      {selectedVersion.policy}
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 80px;

  .center {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (max-width: 768px) {
    padding-top: 60px;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  height: 298px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-03);
  color: var(--grey-50);
  gap: 20px;
  margin: 0;
  .blue__point {
    color: var(--primary);
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    height: fit-content;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 60px;
  }
`;
export default PrivacyPolicy;
